import { render, staticRenderFns } from "./statsTable.vue?vue&type=template&id=89265118&scoped=true"
import script from "./statsTable.vue?vue&type=script&lang=js"
export * from "./statsTable.vue?vue&type=script&lang=js"
import style0 from "./statsTable.vue?vue&type=style&index=0&id=89265118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89265118",
  null
  
)

export default component.exports